import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants } from '../../constants/Constants';

//base
import { BaseDropdownComponent } from '../../baseclasses/BaseDropdown.component';

@Component({
    selector: 'my-yesno-dropdown',
    templateUrl: './YesNODropdown.component.html',
    providers: [{ provide: BaseDropdownComponent, useExisting: forwardRef(() => YesNoDropdownComponent) }]
})
export class YesNoDropdownComponent extends BaseDropdownComponent {


    constructor(private domainDataService: serv.DomainDataService) {
        super();
    }


    ngOnInit(): void {
    }



    public load() {
        this.selectItems.push({ label: "", value: Constants._NONE });
        this.selectItems.push({ label: "Yes", value: Constants._YES });
        this.selectItems.push({ label: "No", value: Constants._NO });
        if (this.value === null || this.value === undefined || this.value === "") {
            this.value = Constants._NONE;
        }
        this.loadDone.emit(this.value);
    }
}